import { useState } from 'react';
import './FaqBlock.css';

const FaqBlock = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'How can I earn money?',
      answer: 'Affiliates earn commission for every qualified player referred to our brands. The stronger and more consistent your traffic, the greater your earning potential. When a referred player registers and makes a deposit, you earn commission based on the commercial agreement we establish together.'
    },
    {
      question: 'Why join Winning Partner?',
      answer: 'Winning Partner offers access to a growing portfolio of casino and sportsbook brands, along with competitive commission structures and dedicated affiliate management support. We also provide detailed performance reporting tools, giving you full visibility into your traffic, player activity, and earnings.'
    },
    {
      question: 'How does the sign-up process work?',
      answer: 'Getting started is simple. Complete the registration form with the required information, and our team will review your application. Once approved, you\'ll receive access to your affiliate dashboard and marketing materials.'
    },
    {
      question: 'How can I monitor my earnings?',
      answer: 'Our platform includes comprehensive reporting tools that allow you to track performance daily, monthly, and per player. The dashboard is designed to provide full transparency, helping you analyse and optimise your campaigns effectively.'
    },
    {
      question: 'Are there any sign-up fees or hidden costs?',
      answer: 'No. Joining Winning Partner is completely free. There are no hidden fees or setup costs — you simply promote our brands and earn commission on qualified traffic.'
    }
  ];

  return (
    <div className="faq-block" id="section-faqs">
      <h2 className="faq-block__title">FAQ'S</h2>
      <div className="faq-block__list">
        {faqs.map((faq, index) => (
          <div key={index} className="faq-block__item">
            <button
              className="faq-block__question"
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
            >
              <span>{faq.question}</span>
              <span className="faq-block__icon">{openIndex === index ? '−' : '+'}</span>
            </button>
            {openIndex === index && (
              <div className="faq-block__answer">{faq.answer}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FaqBlock;
